module.exports = require('./Input')
